export type ExportViewportImageOutput =
	| {
			exported: true;
			format: "png";
			width: number;
			height: number;
			byteSize: number;
			base64: string;
			shapeCount: number;
			scope?: "explicit" | "session" | "selection";
			scale?: number;
	  }
	| {
			exported: false;
			reason: string;
			width?: number;
			height?: number;
	  };

export function isExportViewportImageOutput(
	output: unknown,
): output is ExportViewportImageOutput {
	if (typeof output !== "object" || output === null) {
		return false;
	}

	return typeof (output as ExportViewportImageOutput).exported === "boolean";
}

export function exportViewportImageSummaryForModel(
	output: Extract<ExportViewportImageOutput, { exported: true }>,
) {
	return {
		exported: output.exported,
		format: output.format,
		width: output.width,
		height: output.height,
		byteSize: output.byteSize,
		shapeCount: output.shapeCount,
		scope: output.scope,
		scale: output.scale,
	};
}

export function exportViewportImageDataUrl(
	output: Extract<ExportViewportImageOutput, { exported: true }>,
) {
	return `data:image/${output.format};base64,${output.base64}`;
}
